import { css } from '@emotion/react'

export const styles = {
  rotateRight: css`
    transform: rotate(180deg);
  `,
}
